<template>
  <div class="blog-detail-page">
    <!-- SEO Meta Tags -->
    <meta name="description" :content="blog?.meta_description || 'Modern Kurs blog detay sayfası'" />
    <meta name="keywords" :content="blog?.meta_keywords || 'Modern Kurs, blog, eğitim'" />
    <meta name="author" content="Modern Kurs" />
    <meta property="og:title" :content="blog?.title || 'Blog - Modern Kurs'" />
    <meta property="og:description" :content="blog?.meta_description || 'Blog detay sayfası'" />
    <meta property="og:type" content="article" />
    <meta property="og:url" :content="`https://modernkurs.com/blog/${blog?.id}`" />

    <!-- Navigation Bar -->
    <CorporateNavbar />

    <!-- Blog Detail Content -->
    <section class="blog-detail-content">
      <div class="container">
        <div v-if="blog" class="blog-detail">
          <!-- Back Button -->
          <div class="back-button">
            <router-link to="/blogs" class="btn btn-outline">
              ← Blog Listesine Dön
            </router-link>
          </div>

          <!-- Blog Header -->
          <div class="blog-header">
            <div class="blog-meta">
              <span class="blog-category">{{ blog.category }}</span>
              <span class="blog-date">{{ formatDate(blog.created_at) }}</span>
            </div>
            <h1 class="blog-title">{{ blog.title }}</h1>
          </div>

          <!-- Blog Image -->
          <div v-if="blog.image_url" class="blog-image">
            <img :src="resolveImageUrl(blog.image_url)" :alt="blog.title" />
          </div>

          <!-- Blog Content -->
          <div class="blog-content">
            <div class="content-text">
              {{ blog.content }}
            </div>
          </div>

          <!-- Blog Footer -->
          <div class="blog-footer">
            <div class="blog-tags">
              <span class="tag">{{ blog.category }}</span>
              <span class="tag">Eğitim</span>
              <span class="tag">Modern Kurs</span>
            </div>
                         <div class="share-buttons">
               <button class="share-btn whatsapp-btn" @click="shareOnWhatsApp">
                 <svg class="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                 </svg>
                 WhatsApp'ta Paylaş
               </button>
             </div>
          </div>
        </div>

        <!-- Loading State -->
        <div v-else-if="loading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>Blog yazısı yükleniyor...</p>
        </div>

        <!-- Not Found State -->
        <div v-else class="not-found-state">
          <div class="not-found-icon">📝</div>
          <h3>Blog Yazısı Bulunamadı</h3>
          <p>Aradığınız blog yazısı mevcut değil veya kaldırılmış olabilir.</p>
          <router-link to="/blogs" class="btn btn-primary">Blog Listesine Dön</router-link>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <CorporateFooter />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import CorporateNavbar from '@/components/CorporateNavbar.vue'
import CorporateFooter from '@/components/CorporateFooter.vue'

export default {
  name: 'BlogDetail',
  components: {
    CorporateNavbar,
    CorporateFooter
  },
  setup() {
    const route = useRoute()

    // Blog state
    const blog = ref(null)
    const loading = ref(true)

    const loadBlog = async () => {
      const blogId = parseInt(route.params.id)
      if (!blogId) {
        loading.value = false
        return
      }
      try {
        const res = await axios.get(`/api/blogs/${blogId}`)
        blog.value = res.data
      } catch (err) {
        console.error('Blog yüklenemedi:', err)
        blog.value = null
      } finally {
        loading.value = false
      }
    }

    // Görsel URL çözümleme
    const resolveImageUrl = (url) => {
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      if (url.startsWith('/uploads/')) return axios.defaults.baseURL + url
      return url
    }

    // Tarih formatı
    const formatDate = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }

    // WhatsApp paylaşım fonksiyonu
    const shareOnWhatsApp = () => {
      if (!blog.value) return
      const url = encodeURIComponent(window.location.href)
      const title = encodeURIComponent(blog.value.title)
      const message = `${title}\n\n ${url}`
      window.open(`https://wa.me/?text=${message}`, '_blank')
    }

    onMounted(loadBlog)

    return {
      blog,
      loading,
      formatDate,
      shareOnWhatsApp,
      resolveImageUrl
    }
  }
}
</script>

<style scoped>
.blog-detail-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  overflow-x: hidden;
  width: 100%;
}

.blog-detail-content {
  margin-top: 130px;
  flex: 1;
  padding: 3rem 0;
  background: #f8f9fa;
}

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 3rem;
  }

.back-button {
  margin-bottom: 2rem;
}

.blog-detail {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 0 auto;
}

.blog-header {
  margin-bottom: 2rem;
  text-align: center;
}

.blog-meta {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.blog-category {
  background: #667eea;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.blog-date {
  color: #666;
  font-size: 0.9rem;
}

.blog-title {
  font-size: 2.5rem;
  color: #2c3e50;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
}

.blog-image {
  margin-bottom: 2rem;
  text-align: center;
}

.blog-image img {
  max-width: 600px;
  width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.blog-content {
  margin-bottom: 3rem;
}

.content-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  text-align: justify;
  max-width: 100%;
  margin: 0 auto;
  white-space: pre-line;
}

.blog-footer {
  border-top: 1px solid #eee;
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.blog-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag {
  background: #f0f0f0;
  color: #666;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

.share-buttons {
  display: flex;
  gap: 1rem;
}

.share-btn {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.share-btn:hover {
  background: #5a67d8;
  transform: translateY(-2px);
}

.loading-state,
.not-found-state {
  text-align: center;
  padding: 4rem 0;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.not-found-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.btn {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5a67d8;
  transform: translateY(-2px);
}

.btn-outline {
  background: transparent;
  color: #667eea;
  border: 2px solid #667eea;
}

.btn-outline:hover {
  background: #667eea;
  color: white;
}

/* WhatsApp Paylaşım Butonu */
.whatsapp-btn {
  background: #25D366;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}

.whatsapp-btn:hover {
  background: #128C7E;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
}

.whatsapp-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 1200px) {
  .container {
    max-width: 1000px;
    padding: 0 2rem;
  }

  .blog-detail {
    max-width: 1000px;
  }

  .blog-image img {
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
  }

  .blog-detail {
    padding: 2rem;
    max-width: 100%;
  }

  .blog-image img {
    max-width: 400px;
  }

  .blog-title {
    font-size: 2rem;
  }

  .blog-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .share-buttons {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .blog-detail {
    padding: 1.5rem;
  }

  .blog-image img {
    max-width: 300px;
  }

  .blog-title {
    font-size: 1.8rem;
  }

  .content-text {
    font-size: 1rem;
  }
}
</style>
